export default () => ({
  // 待处理的任务数据
  pendingTask: null,
  // 操作类型: 'regenerate' | 're-edit' | null
  pendingAction: null,

  // 历史记录缓存（按工具类型分组）
  // 格式: { 'text-to-image': [...tasks], 'image-to-image': [...tasks] }
  historyCache: {},
});
